import React, { useMemo, useState } from "react";
import Slider from "react-slick";
import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Select,
} from "@chakra-ui/react";
import { FiExternalLink } from "react-icons/fi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import {
  BRANDS_LIST,
  getAxiosConfig,
  getMaterialPills,
  getUpdatedImageUrlWithSize,
} from "../../../utils/helpers";
import ImgOptimized from "../../../components/ImgOptimized";
import FullPageImageSlider from "../../../components/FullPageImageSlider";
import classNames from "classnames";
import { toast } from "react-toastify";

const MaterialCard = ({
  material,
  selectedMaterials,
  handleAddMaterialToProject,
  isSidebarOpen,
  isClientSelection = false,
  isClickable = false,
  canClick = false,
  showMoreInfo = false,
  isRecommended = false,
  isDelete = false,
  afterDeleteCb = () => {},
}) => {
  const IS_SELECTED =
    Array.isArray(selectedMaterials) &&
    selectedMaterials.includes(material._id);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedImageIdx, setSelectedImageIdx] = useState(null);
  const [isQuantityModalOpen, setIsQuantityModalOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [unit, setUnit] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: Math.random() * 2000 + 2000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    width: "100%",
    height: "100%",
  };

  const handleProductUrlClick = (e) => {
    e.stopPropagation();
    if (material?.otherDetails?.productUrl) {
      window.open(material.otherDetails.productUrl, "_blank");
    }
  };

  const handleCardClick = (e) => {
    if (!canClick) {
      return;
    }
    e && e?.stopPropagation && e.stopPropagation();
    if (!IS_SELECTED && isSidebarOpen) {
      if (!isClickable) {
        toast.error("Select zone and area first.");
        return;
      }
      setIsQuantityModalOpen(true);
    } else {
      handleAddMaterialToProject(material?._id, 1, material);
    }
  };

  const handleQuantityConfirm = () => {
    handleAddMaterialToProject(material?._id, quantity, material, unit);
    setIsQuantityModalOpen(false);
    setQuantity(1);
    setUnit("");
  };
  const materialBrand = BRANDS_LIST.find((val) => val?._id == material?.brand);

  const otherDetailsPills = useMemo(() => {
    return getMaterialPills(material?.otherDetails);
  }, [material]);
  const price = useMemo(() => {
    let arr = [];
    if (material?.otherDetails?.salePrice) {
      arr.push(material?.otherDetails?.salePrice);
    }
    if (material?.otherDetails?.mrpPrice) {
      arr.push(material?.otherDetails?.mrpPrice);
    }
    return arr;
  }, [material]);
  // console.log({ material });

  async function handleMaterialDelete() {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this material?",
    );
    if (!isConfirmed) return;
    try {
      setIsDeleting(true);
      await axios.delete(
        `${process.env.REACT_APP_BACK_URL}/api/material/delete/${material?._id}`,
        getAxiosConfig(),
      );
      toast.success("Material deleted successfully");
      afterDeleteCb();
    } catch (error) {
      console.error("Error deleting material", error.message);
      toast.error("Failed to delete material");
    } finally {
      setIsDeleting(false);
    }
  }

  return (
    <>
      <div className="">
        <Box
          h={"100%"}
          bg="#ffffff"
          borderRadius="xl"
          overflow="hidden"
          position="relative"
          minW="300px"
          borderWidth={1}
          display={"flex"}
          flexDirection={"column"}
          onMouseEnter={() => !isSidebarOpen && setIsHovered(true)}
          onMouseLeave={() => !isSidebarOpen && setIsHovered(false)}
          transition="all 0.2s"
          transform={isHovered ? "scale(1)" : "scale(0.97)"}
          // maxH={"450px"}
        >
          {/* asdf */}
          {showMoreInfo && (
            <div
              className={classNames(
                materialBrand?.bg ? `${materialBrand?.bg} p-1` : "",
                "w-14 absolute top-2 left-2 z-10",
              )}
            >
              <ImgOptimized
                src={materialBrand?.logo}
                className={" max-w-14 w-full  mb-1"}
              />
            </div>
          )}
          {isRecommended && (
            <div className="absolute top-2 right-2 z-10 flex items-center gap-1 bg-amber-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full shadow-md">
              <Icon icon="mdi:star" width={14} />
            </div>
          )}
          {isDelete && (
            <div
              className={`absolute text-white top-2 right-2 z-10 flex items-center justify-center rounded-full p-2 shadow-md transition-all ${
                isDeleting
                  ? "bg-red-300 cursor-not-allowed"
                  : "bg-red-500 hover:bg-red-600 cursor-pointer"
              }`}
              onClick={() => !isDeleting && handleMaterialDelete()}
            >
              {isDeleting ? (
                <Icon icon="mdi:loading" width={18} className="animate-spin" />
              ) : (
                <Icon icon="mdi:trash" width={18} />
              )}
            </div>
          )}
          {/* Carousel Section */}
          {/* {IS_SELECTED ?"YES" : "NO"} */}
          <Slider {...settings} className="w-full relative">
            {material?.images?.map((img, idx) => (
              <div
                style={{
                  display: "flex !important",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                key={idx}
                className="bg-[#f6f6f6] w-full h-full p-0 cursor-pointer relative flex items-center justify-center"
                onClick={() => {
                  console.log({
                    IS_SELECTED,
                    isSidebarOpen,
                    isQuantityModalOpen,
                  });
                  if (isSidebarOpen) {
                    handleCardClick();
                  } else {
                    setSelectedImageIdx(idx);
                  }
                }}
              >
                <div className="flex items-center justify-center w-full h-full">
                  <ImgOptimized
                    src={getUpdatedImageUrlWithSize(
                      `${process.env.REACT_APP_BACK_URL}/api/minio/${img}`,
                      [1, 2, 2],
                    )}
                    width="auto"
                    height="auto"
                    alt={`${material?.productCode}-${idx}`}
                    className="max-w-full max-h-[450px] object-contain mx-auto "
                    isLazy={false}
                  />
                </div>

                {isSidebarOpen && (
                  <div
                    className="absolute bottom-2 right-2 w-fit h-fit max-h-6 max-w-6 flex items-center justify-center bg-black bg-opacity-50 rounded-full p-1 text-white hover:bg-opacity-80 transition-all"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedImageIdx(idx);
                    }}
                  >
                    <Icon icon="mdi:fullscreen" width={18} />
                  </div>
                )}
              </div>
            ))}
          </Slider>

          {/* Bottom Info */}
          {showMoreInfo && (
            <Box
              onClick={handleCardClick}
              p={4}
              color="black"
              // bg={'red.400'}
              position={"relative"}
              // className="relative"
              cursor={!IS_SELECTED ? "pointer" : "default"}
            >
              {/* {materialBrand && ( */}
              <div className="flex justify-between items-center">
                {/* {!isClientSelection && (
                <div
                  className={classNames(
                    materialBrand?.bg ? `${materialBrand?.bg} p-1` : "",
                    "w-20",
                  )}
                >
                  <ImgOptimized
                    src={materialBrand?.logo}
                    className={" max-w-20 w-full  mb-1"}
                  />
                </div>
              )} */}
                {price.length != 0 && !isClientSelection && (
                  <div className="flex flex-col items-center  gap-0.5">
                    {price?.[0] && (
                      <p className="font-semibold">
                        ₹
                        {String(price?.[0] || "")
                          ?.replace("₹", "")
                          ?.trim()
                          ?.split(" ")
                          ?.join(",")}
                      </p>
                    )}
                    {/* {price?.[1] &&  <p>{price?.[1]}</p>} */}
                  </div>
                )}
              </div>
              {/* )} */}
              {/* </div> */}
              <Text
                fontWeight="500"
                fontSize="lg"
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                w={"90%"}
              >
                {material.materialName}
              </Text>
              <div className="flex items-center gap-1 flex-wrap mt-4">
                {otherDetailsPills?.size &&
                  otherDetailsPills.size
                    .split(",")
                    .filter((size) => !!size.trim())
                    .map((size, index) => (
                      <div
                        key={index}
                        className="capitalize bg-teal-200 text-teal-600 p-1 text-xs rounded-full border font-semibold border-teal-600"
                      >
                        {size.trim()}
                      </div>
                    ))}
              </div>
              <div
                className={
                  isClientSelection
                    ? "absolute top-4 right-0"
                    : "absolute bottom-2 right-2 "
                }
              >
                {material?.otherDetails?.productUrl && (
                  <Flex
                    onClick={handleProductUrlClick}
                    align="center"
                    gap={2}
                    bg="black"
                    color="white"
                    cursor={"pointer"}
                    px={2}
                    py={2}
                    borderRadius="full"
                    fontWeight="bold"
                    fontSize="md"
                    scale={"0.9"}
                    _hover={{ bg: "teal.600", scale: "1" }}
                    transition="all 0.2s"
                    // transform={isHovered ? "scale(1)" : "scale(0.9)"}
                  >
                    <FiExternalLink size={16} />

                    {/* <Text>Go to Product</Text> */}
                  </Flex>
                )}
              </div>
            </Box>
          )}

          {IS_SELECTED && (
            <div
              onClick={handleCardClick}
              className="absolute top-0 left-0 w-full h-full flex justify-center items-center z-2 bg-teal-500 bg-opacity-30"
            >
              <Icon icon={"mdi:tick-circle"} color="teal" width={32} />
            </div>
          )}
        </Box>
      </div>
      {/* Quantity Modal */}
      <Modal
        isOpen={isQuantityModalOpen}
        onClose={() => setIsQuantityModalOpen(false)}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Quantity</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={4}>How many units would you like to add?</Text>
            <Flex align="end" justify={"space-between"} gap={4} wrap="wrap">
              <Flex align="center" gap={4}>
                <Button
                  size="sm"
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  colorScheme="teal"
                  variant="outline"
                >
                  −
                </Button>
                <Input
                  type="number"
                  value={quantity}
                  onChange={(e) => {
                    const num = parseInt(e.target.value) || 1;
                    setQuantity(Math.max(1, num));
                  }}
                  min={1}
                  w="80px"
                  textAlign="center"
                />
                <Button
                  size="sm"
                  onClick={() => setQuantity(quantity + 1)}
                  colorScheme="teal"
                  variant="outline"
                >
                  +
                </Button>
              </Flex>
              <Flex direction="column" gap={1}>
                <Text fontSize="xs" color="gray.500" fontWeight="medium">
                  Unit of measurement
                </Text>
                <Select
                  size="md"
                  value={unit}
                  onChange={(e) => setUnit(e.target.value)}
                  w="140px"
                  borderRadius="md"
                >
                  <option value="">—</option>
                  {[
                    "Sq.ft",
                    "Rft",
                    "Nos",
                    "Kg",
                    "Ltr",
                    "Cu.m",
                    "Cu.ft",
                    "Sq.m",
                    "Mtr",
                    "Set",
                    "Pair",
                    "Bundle",
                    "Bag",
                    "Box",
                    "Rmt",
                    "Load",
                    "LS",
                    "Lump Sum",
                    "Point",
                    "Bucket",
                  ].map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </Select>
              </Flex>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="ghost"
              mr={3}
              onClick={() => {
                setIsQuantityModalOpen(false);
                setQuantity(1);
                setUnit("");
              }}
            >
              Cancel
            </Button>
            <Button colorScheme="teal" onClick={handleQuantityConfirm}>
              Add to Project
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {selectedImageIdx != null && (
        <FullPageImageSlider
          images={[
            ...material?.images?.map(
              (img, idx) =>
                `${process.env.REACT_APP_BACK_URL}/api/minio/${img}`,
            ),
            ...(material?.family_colors || [])
              ?.filter((v) => v?.productCode != material?.productCode)
              ?.map((v) => {
                console.log({ v, material });
                return v?.images?.map(
                  (img) => `${process.env.REACT_APP_BACK_URL}/api/minio/${img}`,
                );
              })
              .flat(),
          ].flat()}
          isOpen={selectedImageIdx !== null}
          onClose={() => setSelectedImageIdx(null)}
          isMaterial={
            material?.family_colors &&
            Array.isArray(material?.family_colors) &&
            material?.family_colors?.length > 0
          }
          initialIndex={selectedImageIdx}
        />
      )}
    </>
  );
};

export default MaterialCard;
